import { create } from "zustand";
import { GeneralSettingStore } from "./general-setting";
import { DefaultIndexParams } from "../../../types/common";
import { request } from "../../../api/config";

export const useGeneralSettingStore = create<GeneralSettingStore>((set) => ({
  settings: null,
  setting: null,

  loadingSettings: false,
  loadingSetting: false,

  getSettings: async (params?: DefaultIndexParams) => {
    set({ loadingSettings: true });
    try {
      const { data } = await request.get("/setting/general", { params });
      set({ settings: data.data });
    } catch (error) {
    } finally {
      set({ loadingSettings: false });
    }
  },
  getSetting: async (params: DefaultIndexParams & { name: string }) => {
    set({ loadingSetting: true });
    try {
      const { data } = await request.get("/setting/general", { params });
      set({ setting: data.data });
    } catch (error) {
    } finally {
      set({ loadingSetting: false });
    }
  },
}));
